import { createStore } from 'vuex'

export default createStore({
  state: {
    iD: false,
    session: false,
    token: false
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
